import React, { useMemo } from "react";
import { Search } from "lucide-react";
import FormSelect from "../common/FormSelect";
import {
  useGetAllCategoryQuery,
  useGetAllAgeGroupsQuery,
  useGetAllLevelsQuery,
} from "../../services/category";

const typeOptions = [
  { label: "All", value: "all" },
  { label: "Live", value: "live" },
  { label: "Recorded", value: "recorded" },
];

const CoursesFilter = ({ filters, searchTerm, onSearchChange, onFiltersChange }) => {
  const { data: categoriesData } = useGetAllCategoryQuery({
    page: 1,
    limit: 100,
  });
  const { data: ageGroupsData } = useGetAllAgeGroupsQuery();
  const { data: levelsData } = useGetAllLevelsQuery();

  const categoryOptions = useMemo(() => {
    const categories = Array.isArray(categoriesData?.data)
      ? categoriesData.data
      : [];

    return [
      { label: "All Categories", value: "all" },
      ...categories.map((category) => ({
        label: category.categoryName,
        value: category._id,
      })),
    ];
  }, [categoriesData]);

  const ageGroupOptions = useMemo(() => {
    const ageGroups = Array.isArray(ageGroupsData?.data)
      ? ageGroupsData.data
      : [];

    return [
      { label: "All Age Group", value: "all" },
      ...ageGroups.map((ageGroup) => ({
        label: ageGroup.title,
        value: ageGroup._id,
      })),
    ];
  }, [ageGroupsData]);

  const levelOptions = useMemo(() => {
    const levels = Array.isArray(levelsData?.data) ? levelsData.data : [];

    return [
      { label: "All Levels", value: "all" },
      ...levels.map((level) => ({
        label: level.title,
        value: level._id,
      })),
    ];
  }, [levelsData]);

  const handleCategoryChange = (value) => {
    onFiltersChange((current) => ({
      ...current,
      category: value,
      ageGroup: "all",
      level: "all",
    }));
  };

  return (
    <div className="mt-7 grid gap-4 sm:gap-6 xl:gap-10 2xl:gap-14 md:grid-cols-3 lg:grid-cols-5 sm:grid-cols-2 grid-cols-1">
      <div>
        <p className="mb-2.5 text-[15px] leading-[18px] text-[#6B7280]">Search</p>
        <div className="flex h-12 items-center gap-3 border border-[#E9EAF0] bg-white px-4">
          <Search size={24} className="text-[#8C8CA1]" />
          <input
            type="text"
            value={searchTerm}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Search in your courses..."
            className="w-full bg-transparent text-base text-black outline-none placeholder:text-[#8C8CA1] placeholder:opacity-80"
          />
        </div>
      </div>

      <FormSelect
        label="Category"
        options={categoryOptions}
        defaultValue={filters.category}
        onChange={handleCategoryChange}
        selectClassName="!h-12 rounded-none border-[#E9EAF0] text-base"
        labelClassName="mb-2.5 !font-normal !text-[#6B7280] text-[15px] leading-[18px]"
      />

      <FormSelect
        label="Type"
        options={typeOptions}
        defaultValue={filters.type}
        onChange={(value) =>
          onFiltersChange((current) => ({ ...current, type: value }))
        }
        selectClassName="!h-12 rounded-none border-[#E9EAF0] text-base"
        labelClassName="mb-2.5 !font-normal !text-[#6B7280] text-[15px] leading-[18px]"
      />

      <FormSelect
        label="Age Group"
        options={ageGroupOptions}
        defaultValue={filters.ageGroup}
        onChange={(value) =>
          onFiltersChange((current) => ({ ...current, ageGroup: value }))
        }
        selectClassName="!h-12 rounded-none border-[#E9EAF0] text-base"
        labelClassName="mb-2.5 !font-normal !text-[#6B7280] text-[15px] leading-[18px]"
      />

      <FormSelect
        label="Level"
        options={levelOptions}
        defaultValue={filters.level}
        onChange={(value) =>
          onFiltersChange((current) => ({ ...current, level: value }))
        }
        selectClassName="!h-12 rounded-none border-[#E9EAF0] text-base"
        labelClassName="mb-2.5 !font-normal !text-[#6B7280] text-[15px] leading-[18px]"
      />
    </div>
  );
};

export default CoursesFilter;
